import UserActions from 'app/shared/flux/actions/UserActions';
import filterUtils from 'app/shared/utils/filterUtils';
import { decodeFullAddressFromUrl } from 'app/shared/utils/urlUtils';
import { loadFilterFromUrl } from 'app/shared/flux/actions/FilterActions';
import { augmentError, formatForLog } from 'app/shared/utils/errors';
import { getAddressAndComparables } from 'app/shared/flux/actions/AddressActions';

const logger = getLogger('pages/PriceMyRentalResultsPage');

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  const { dispatch } = store;
  // Get user info
  dispatch(UserActions.getUser());
  const state = store.getState();
  const pathname = state.router.location.pathname;
  const queryObject = state.router.location.query;
  const queryString = state.router.location.search;
  const filterParams = filterUtils.queryStringToGraphQLParams(queryString);
  const addressDataObject = decodeFullAddressFromUrl({
    pathname,
    unit: queryObject.unit,
  });
  const params = { ...addressDataObject, ...filterParams };

  // @ts-ignore
  dispatch(loadFilterFromUrl(queryObject)).catch((err) => {
    augmentError(err, {
      root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
    });

    logger.error(formatForLog(err), 'Results page: Error loading filter from url (SSR)');
  });

  // @ts-ignore
  return dispatch(getAddressAndComparables(params)).catch((err) => {
    augmentError(err, {
      root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
      pathAttempted: pathname,
      queryAttempted: queryString,
    });
    logger.error(formatForLog(err), 'Results page: Error loading address/comps (SSR)');
  });
};
export default serverRouteWillMount;
